var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.44,
    height: 17.28,
    viewBox: "0 0 10.13 13.04"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.06 11v2h-10v-2z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy40NCIgaGVpZ2h0PSIxNy4yOCIgdmlld0JveD0iMCAwIDEwLjEzIDEzLjA0IiBmaWxsPSIjMDA0YTg1Ij4KICAgIDxwYXRoIGQ9Ik0xMC4wNiAxMXYyaC0xMHYtMnoiIGZpbGw9IiMwMDRhODUiIC8+Cjwvc3ZnPgo=";
export { SvgDownloadBar as ReactComponent };